"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ExchangeonlineGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M9.65 13.256l-.71.686-1.385 1.343a1.59 1.59 0 01-1.1.448H3.071c-.862 0-1.562-.7-1.562-1.562v-3.235H2.7v3.235c0 .204.168.371.372.371h3.382c.1 0 .196-.038.267-.105l1.843-1.79.258-.248.829.857zM16 2.805v3.382c0 .42-.162.81-.457 1.105L14.18 8.578l-.647.605-.815-.867.129-.119 1.867-1.757a.366.366 0 00.095-.253V2.805a.372.372 0 00-.371-.371h-3.382a.384.384 0 00-.262.11L9.35 3.986v2.105a2.992 2.992 0 01-1.59 2.644 2.877 2.877 0 01-1.191.343V7.883c.476-.052.9-.3 1.19-.657.253-.31.4-.705.4-1.134v-2.6L9.952 1.7c.295-.295.69-.457 1.105-.457h3.382c.862 0 1.562.7 1.562 1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M15.4 9.798l-1.22-1.22-.033-.033-.348-.348h-2.705a2.534 2.534 0 00-2.53 2.53v2.796l.305.338.072.081 1.052 1.172.02.023.023.024c.362.362.863.567 1.372.567h2.625a1.94 1.94 0 001.938-1.938v-2.62c0-.52-.204-1.005-.571-1.372zm-.62 3.992a.746.746 0 01-.747.747h-2.625a.739.739 0 01-.529-.219l-1.124-1.252v-2.34c0-.742.6-1.338 1.339-1.338h2.215l1.253 1.253a.75.75 0 01.219.529v2.62zM9.203 3.344l-.891.79-.152-.171-1.491-1.686a.39.39 0 00-.243-.086H3.049a.373.373 0 00-.377.371V5.56h-1.19V2.562C1.481 1.7 2.181 1 3.048 1h3.377c.414 0 .82.167 1.11.457l1.248 1.41.419.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.112 4.368H.648A.648.648 0 000 5.015v6.464c0 .358.29.648.648.648h6.464c.357 0 .647-.29.647-.648V5.015a.648.648 0 00-.647-.647zm-.543 6.568H1.19V5.56h5.378v5.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M7.112 4.368H.648A.648.648 0 000 5.015v6.464c0 .358.29.648.648.648h6.464c.357 0 .647-.29.647-.648V5.015a.648.648 0 00-.647-.647zm-.543 6.568H1.19V5.56h5.378v5.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M4.916 7.088H3.434v.867h1.391v.557h-1.39v.9h1.562v.553H2.763v-3.43h2.153v.557-.004z"
  }));
}

ExchangeonlineGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ExchangeonlineGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ExchangeonlineGreyOutline;
exports["default"] = _default;